import RectangleGroupIcon from "@heroicons/react/24/outline/RectangleGroupIcon";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { styled as styling } from "@mui/material/styles";
import Color from "../../../assets/colors";

export const GridStyled = styling(Grid)({
  //
});

export const ImageStyled = styling("img")({
  objectFit: "cover",
  width: "100%",
  borderRadius: "10px",
  height: "100%",
  cursor: "pointer",

  "@media (max-width: 640px)": {
    minWidth: "300px",
  },
});

export const ShowAllMediaButton = styling(Button)({
  fontWeight: "400",
  padding: "5px 7px",
  border: `1px solid ${Color.black}`,
  gap: "12px",
  textTransform: "capitalize",
  position: "absolute",
  right: "10px",
  bottom: "10px",
  backgroundColor: Color.white,
  color: "rgba(0, 0, 0, 0.87)",

  transition: "all 0.075s ease-in-out",

  "@media (min-width: 1280px)": {
    "&:hover": {
      backgroundColor: Color.white,
      border: `1px solid ${Color.black}`,
      boxShadow: "2px 2px 0px rgba(0, 0, 0, 1)",
      transform: "translate(-2px, -2px)",
      cursor: "pointer",
    },
  },
});

export const ShowAllMediaIcon = styling(RectangleGroupIcon)({
  height: "24px",
  width: "24px",
});

export const OutlinedButton = styling(Button)((props) => ({
  gap: "0.65rem",
  textTransform: "capitalize",
  color: "rgba(0, 0, 0, 0.87)",
  fontSize: "16px",
  fontWeight: "400",
  padding: "15px 30px",
  borderRadius: "8px",

  backgroundColor: Color.white,
  border: `1.5px solid ${Color.black}`,

  "@media (min-width: 1280px)": {
    "&:hover": {
      backgroundColor: Color.white,
      boxShadow: "0px 4px 0px 0px rgba(0,0,0,1)",
      border: `1.5px solid ${Color.black}`,
    },
  },

  "@media (max-width: 640px)": {
    width: "100%",
  },
}));

export const SkeletonContainer = styling("div")({
  minHeight: "370px",
  minWidth: "1240px",
});
